export default {

  namespaced: true,

  state: () => ({

    persons: {},
    export_persons: {},

  }),

  mutations: {
    setPersons(state, persons) {
      state.persons = persons
    },

    setExportPersons(state, data) {
      state.export_persons = data
    }
  },

  actions: {

    async getPersons({ dispatch, commit }, params) {

      await axios.get("/erp/person/person", { params })
        .then(response => {

          commit('setPersons', response.data.person)

        }).catch(error => {

          //commit("userHasLoadedWithError", { error: error }, { root: true });

        })
    },

    async storePerson({ dispatch, commit }, params) {

      const data = await axios.post("/erp/person/person", params);

      return data;

    },


    async exportPersons({ dispatch, commit }) {
      await axios({
        url: '/erp/person/export', method: 'POST', responseType: 'blob'
      })
        .then(response => {
          commit('setExportPersons', response)
        }).catch(error => { console.log(error) })
    },

    async getReport({ commit }, params) {
      const data = await axios.get('/erp/person/report', { params: params });
      return data;
    }
  }
}
